// import { nfdrs_risk_colors } from "./nfdrs_colors";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { fromLonLat } from "ol/proj";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Style from "ol/style/Style";
import Text from "ol/style/Text";
import Circle from "ol/style/Circle";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import {kbdiColor,
    burningIndexColor,
    ignitionComponentColor,
    spreadComponentColor,
    energyReleaseComponentColor,
    tenHrFuelIndexColor,
    hunHrFuelIndexColor,
    thHrFuelIndexColor,
} from '../wims_layers_colormaps';
import {wims_meta} from '../wims_ids';
// Updated WimsLayers function
function WimsLayers(nysmData) {
    const features = makeFeature(nysmData);
    const vectorSource = makeVectorSource(features);
    const layers = makeSelectedLayers(vectorSource);
    return features;
}

// Updated TextStyle function to include color mapping
const TextStyle = (parameter, value) => {
    let color;
    switch (parameter) {
        case 'kbdi':
            color = kbdiColor(value);
            break;
        case 'ignition_component':
            color = ignitionComponentColor(value);
            break;
        case 'spread_component':
            color = spreadComponentColor(value);
            break;   
        case 'energy_release_component':
            color = energyReleaseComponentColor(value);
            break;       
        case 'burning_index':
            color = burningIndexColor(value);
            break;   
        case 'tenhrfm':
            color = tenHrFuelIndexColor(value);
            break; 
        case 'hunhrfm':
            color = hunHrFuelIndexColor(value);
            break; 
        case 'thhrfm':
            color = thHrFuelIndexColor(value);
            break; 
        default:
            color = '#e6e6e633'; // Fallback color (transparent)
            break;
    }
    return [MakeStyleText(color, value)];
}

const getNFDRSStyle = (parameter, feature) => {
  const value = feature.get(parameter);

  let color;
  switch (parameter) {
    case 'kbdi':
      color = kbdiColor(value);
      break;
    case 'ignition_component':
      color = ignitionComponentColor(value);
      break;
    case 'spread_component':
      color = spreadComponentColor(value);
      break;
    case 'energy_release_component':
      color = energyReleaseComponentColor(value);
      break;
    case 'burning_index':
      color = burningIndexColor(value);
      break;
    case 'tenhrfm':
      color = tenHrFuelIndexColor(value);
      break;
    case 'hunhrfm':
      color = hunHrFuelIndexColor(value);
      break;
    case 'thhrfm':
      color = thHrFuelIndexColor(value);
      break;
    default:
      color = '#e6e6e633';
  }

  return MakeStyleText(color, value);
};


// You can add more color mapping functions for other indices (e.g., ic, sc, erc, etc.)

const makeFeature = (data) => {
    let feat = [];
    for (const i in data) {
        var stid = (data[i]['StationID']);
        var station_info = wims_meta.find(stn => stn["stid"] === stid);

        var station = stid;
        var wims_id = station_info ? station_info['WIMS ID']: null;
        var name = station_info ? station_info['name']: null;

        var lat = station_info ? station_info['lat [degrees]']: null;
        var lon = station_info ? station_info['lon [degrees]']: null;
        var kbdi = data[i]['KBDI'];
        var hrfm = data[i]['1HourDFM(%)'];
        var tenhrfm = data[i]['10HourDFM(%)'];
        var hunhrfm = data[i]['100HourDFM(%)'];
        var thhrfm = data[i]['1000HourDFM(%)'];
        var ic = data[i]['IC'];
        var sc = data[i]['SC'];
        var erc = data[i]['ERC'];
        var bi = (data[i]['BI']);
        //var fl = data[i]['fl'];
        //var sl = data[i]['sl'];
        var nfdr = (data[i]['adj']);
        var ftemp = data[i]['FuelTemp(C)'];

        if (kbdi && lat && lon){
            feat.push(new Feature({
                geometry: new Point(fromLonLat([ lon, lat ])),
                lat: lat,
                lon: lon,
                station: station,
                station_name: station,
                type: "nfdr_station",
                name: name,
                wims_id: wims_id,
                stid: stid,
                kbdi: kbdi,
                tenhrfm: tenhrfm,
                hunhrfm: hunhrfm,
                thhrfm: thhrfm,
                spread_component: sc,
                energy_release_component: erc,
                burning_index: bi,
                //fire_load: fl,
                ignition_component: ic,
                //staffing_level: sl,
                //nfdr: nfdr,
                ftemp: ftemp,
            }));
        }
    }

    return feat;
}

const makeVectorSource = (features) => {
    const vectorSource = new VectorSource({features});
    return vectorSource;
}

function makeSelectedLayers(vectorSource) {
    const Layers = {
        "ic": makeTextLayer(vectorSource, 'ignition_component'),
        "sc": makeTextLayer(vectorSource, 'spread_component'),
        "ec": makeTextLayer(vectorSource, 'energy_release_component'),
        "bi": makeTextLayer(vectorSource, 'burning_index'),
        "fl": makeTextLayer(vectorSource, 'fire_load'),
        "sl": makeTextLayer(vectorSource, 'staffing_level'),
        "kbdi": makeTextLayer(vectorSource, 'kbdi'),
        "ten_hr": makeTextLayer(vectorSource, 'tenhrfm'),
        "hu_hr": makeTextLayer(vectorSource, 'hunhrfm'),
        "th_hr": makeTextLayer(vectorSource, 'thhrfm'),
    }
    return Layers;
}

const makeTextLayer = (vectorSource, parameter) => {
    const vectorLayer = new VectorLayer({
        source: vectorSource,
        style: function(feature){
            return TextStyle(parameter, feature.get(parameter));
        },
        title: "WIMS Layer",
    });
    vectorLayer.set("layerType", "stations")
    vectorLayer.setZIndex(0);
    return vectorLayer;
}

const nysm_circle = new Circle( {
    radius: 12,
    fill: new Fill( {
        color: 'rgb(230,230,230, 0.1)'    } )
} );


const whiteStroke = new Stroke({ color: "white", width: 3 });
const blackStroke = new Stroke({ color: "#000", width: 1 });
const orangeStroke = new Stroke({ color: "orange", width: 3 });
const circleStroke = new Stroke({ color: "#444", width: 1 });
const textFill = new Fill({ color: "#fff" });

const MakeStyleText = (color, value) => {
    const styleText = new Style( {
        text: new Text( {
            font: "bold 16px sans-serif",
            scale: 1,
            text: parseInt(value).toString(),
            fill: textFill,
            stroke: blackStroke,
        } ),
        image: new Circle( {
            radius: 18,
            fill: new Fill( {
                color: color
            } ),
            stroke: circleStroke,

        } ),
        //image: nysm_circle
    } );
    return styleText;
}

function getStidByWimsId(wimsId) {
    const station = wims_meta.find(stn => stn["WIMS ID"] === wimsId);
    return station ? station.stid : null;
  }


export { WimsLayers, getNFDRSStyle };
